exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-33d32a5f] {\n  white-space: nowrap;\n  position: relative;\n  top: -1px;\n}\n", ""]);

// exports
